var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.001,
    viewBox: "0 0 16 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_Contact",
    "data-name": "Icon Contact",
    d: "M4.816,1.05a1.567,1.567,0,0,1,1.827.881h0L8.03,5.054a1.568,1.568,0,0,1-.453,1.859l-1.154.923a12.308,12.308,0,0,0,3.741,3.741l.923-1.154.416.333-.416-.334a1.568,1.568,0,0,1,1.859-.451h0l3.123,1.387a1.567,1.567,0,0,1,.881,1.826l-.685,2.64h0a1.573,1.573,0,0,1-1.737,1.161h0A15.873,15.873,0,0,1,1.015,3.474h0A1.573,1.573,0,0,1,2.176,1.735h0l2.64-.685Zm7.1,10.04h0L10.7,12.611a.533.533,0,0,1-.687.127A13.375,13.375,0,0,1,5.262,7.984.533.533,0,0,1,5.389,7.3L6.91,6.081a.5.5,0,0,0,.145-.594h0L5.668,2.364a.5.5,0,0,0-.584-.282l-2.639.685h0a.507.507,0,0,0-.374.559,14.806,14.806,0,0,0,12.6,12.6.507.507,0,0,0,.559-.373h0l.685-2.639s0,0,0,0a.5.5,0,0,0-.281-.583l-3.123-1.387a.5.5,0,0,0-.594.144Z",
    transform: "translate(-1 -1)",
    fill: "#767676",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact);
export default __webpack_public_path__ + "static/media/Icon_Contact.cd0470f5d9a941299d9998b0c871d565.svg";
export { ForwardRef as ReactComponent };